/** The API accepts at most this many `exclude_prompt_ids` (more is a 422). */
export const MAX_EXCLUDED_PROMPT_IDS = 200;

/** The newest ids only: the oldest repeats matter least. Returns the input when it is short enough. */
export function capExcludedPromptIds(ids: readonly number[]): number[] {
  return ids.length > MAX_EXCLUDED_PROMPT_IDS
    ? ids.slice(-MAX_EXCLUDED_PROMPT_IDS)
    : [...ids];
}
